var React = require('react');

function Nodrycl (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Desktop---Phase-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"Ikoner/Do-not-dry-clean","transform":"translate(.333 .078)","stroke":"#000","strokeWidth":"2"},[React.createElement("g",{"id":"x","fillRule":"evenodd","transform":"translate(1 .575)","strokeLinecap":"square","key":0},[React.createElement("path",{"d":"M36.924 1.005L.96 37.624","id":"Line-29","key":0}),React.createElement("path",{"d":"M.96 1.005l35.964 36.619","id":"Line-29-Copy","key":1})]),React.createElement("circle",{"id":"Oval-11","cx":"20","cy":"20","r":"17","key":1})])));
}

Nodrycl.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40"};

module.exports = Nodrycl;

Nodrycl.default = Nodrycl;
